import {
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    Typography,
    IconButton,
    CircularProgress,
    Box,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Divider,
    Button
} from '@mui/material'
import PrintIcon from '@mui/icons-material/Print'
import CloseIcon from '@mui/icons-material/Close'
import { useEffect, useState } from 'react'
import axios from 'axios'
import apiUrl from "../../../configs/constant";
import { useToast } from '../../ToastProvider';

type Props = {
    open: boolean
    onClose: () => void
    id: number
    tabel: string
}

export default function JurnalModal({ open, onClose, id, tabel }: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState<any[]>([])
    const [header, setHeader] = useState<any>(null)

    const fetchJurnal = async () => {
        try {
            setLoading(true)

            const url = apiUrl.apiUrl + '/acc/jurnal/get-jurnal'

            axios
                .get(url, {
                    params: { id, tabel },
                    headers: { Authorization: `Bearer ${token}` }
                })
                .then(response => {
                    if (response.data.success) {

                        setData(response.data?.detail || [])
                        setHeader(response.data?.data || {})

                        setLoading(false)
                    } else {
                        showToast(response.data.message, 'error');
                    }
                })
        } catch (err) {
            console.error(err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (open) fetchJurnal()
    }, [open])

    const totalDebit = data.reduce((acc, row) => acc + Number(row.debet ?? 0), 0)
    const totalKredit = data.reduce((acc, row) => acc + Number(row.kredit ?? 0), 0)

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Lihat Jurnal

                <Box>
                    {header === null ? (
                        ''
                    ) : (
                        <>
                            <Button
                                variant="outlined"
                                size="small"
                                startIcon={<PrintIcon />}
                                onClick={() => window.open(apiUrl.baseUrl + '/acc/jurnal-memorial/pdf/' + header?.id, '_blank')}
                                sx={{ mr: 1 }}
                            >
                                Cetak
                            </Button>
                        </>
                    )}

                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent dividers>
                {loading ? (
                    <Box textAlign="center" py={5}>
                        <CircularProgress disableShrink sx={{ mt: 6, height: '100%' }} />
                    </Box>
                ) : (
                    <>
                        <Grid container spacing={2} mb={2}>
                            {/* LEFT */}
                            <Grid item xs={12} md={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={4}>
                                        <Typography variant="body2">ID</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography variant="body2">: {header?.id ?? '-'}</Typography>
                                    </Grid>

                                    <Grid item xs={4}>
                                        <Typography variant="body2">Tanggal</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography variant="body2">
                                            : {header?.tgl
                                                ? new Date(header.tgl).toLocaleString('id-ID', {
                                                    day: '2-digit',
                                                    month: 'long',
                                                    year: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit'
                                                })
                                                : '-'}
                                        </Typography>
                                    </Grid>

                                </Grid>
                            </Grid>

                            {/* RIGHT */}
                            <Grid item xs={12} md={6}>
                                <Grid container spacing={1}>

                                    <Grid item xs={4}>
                                        <Typography variant="body2">Status</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography variant="body2">
                                            : {header?.is_posted ? 'POSTED' : 'BELUM POSTING'}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {/* FULL ROW */}
                            <Grid item xs={12}>
                                <Grid container spacing={1}>
                                    <Grid item xs={2}>
                                        <Typography variant="body2">Transaksi</Typography>
                                    </Grid>
                                    <Grid item xs={10}>
                                        <Typography variant="body2">
                                            : {header?.keterangan ?? '-'}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>


                        <Divider sx={{ mb: 2 }} />

                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Akun</TableCell>
                                    <TableCell>Nama Akun</TableCell>
                                    <TableCell align="right">Debet</TableCell>
                                    <TableCell align="right">Kredit</TableCell>
                                    <TableCell>Keterangan</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {data.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            Tidak ada data
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    <>
                                        {data.map((row, i) => (
                                            <TableRow key={i}>
                                                <TableCell>{row.nomor_akun}</TableCell>
                                                <TableCell>{row.nama_akun}</TableCell>
                                                <TableCell align="right">
                                                    {Number(row.debet ?? 0).toLocaleString()}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {Number(row.kredit ?? 0).toLocaleString()}
                                                </TableCell>
                                                <TableCell>{row.keterangan}</TableCell>
                                            </TableRow>
                                        ))}

                                        {/* 🔥 TOTAL ROW */}
                                        <TableRow sx={{ borderTop: '2px solid #000' }}>
                                            <TableCell colSpan={2}>
                                                <strong>Total</strong>
                                            </TableCell>

                                            <TableCell align="right">
                                                <strong>{totalDebit.toLocaleString()}</strong>
                                            </TableCell>

                                            <TableCell align="right">
                                                <strong>{totalKredit.toLocaleString()}</strong>
                                            </TableCell>

                                            <TableCell />
                                        </TableRow>
                                    </>
                                )}
                            </TableBody>
                        </Table>
                    </>
                )}
            </DialogContent>
        </Dialog>
    )
}
